"use client";

import { usePathname } from "next/navigation";
import AnnouncementBanner from "@/components/ui/announcement-banner";
import Header from "@/components/ui/header";
import Footer from "@/sections/footer";
type RouteShellProps = {
  children: React.ReactNode;
};

export default function RouteShell({ children }: RouteShellProps) {
  const pathname = usePathname() ?? "";
  /* Chrome is hidden on campaign pages and partner microsites — surfaces with
     their own frame, reached from an ad or a partner, where the site's nav
     would be noise.

     It is NOT hidden on pages a search result can land on. `/gaseste-terapeut`
     and `/sesiune-cunoastere` were both in this list from when they were
     funnels; they are now 1,000+ word pages that rank, and a visitor arriving
     from Google on a page with no nav and no footer has nowhere to go next. */
  const hideChrome =
    pathname.startsWith("/retreat") ||
    pathname.startsWith("/webinar-burnout") ||
    (pathname.startsWith("/webinar-limite") &&
      // The post-event feedback form lives inside the site: attendees who
      // finish it should be able to keep going.
      !pathname.startsWith("/webinar-limite/feedback"));
  const hideFooter = hideChrome || pathname.startsWith("/zenyra/chat");
  /* The mobile dock is fixed to the bottom of the viewport, so the last of the
     page needs room to clear it. Only where the dock actually renders. */
  const showsDock = !hideChrome && !pathname.startsWith("/zenyra");

  /* The banner promotes the webinar, so it has no business on the webinar's own
     page, and it scrolls away with the header rather than sticking. */
  const showsBanner = !hideChrome && !pathname.startsWith("/webinar-");

  return (
    <>
      {showsBanner && <AnnouncementBanner />}
      {!hideChrome && <Header />}
      <main className="relative z-10">{children}</main>
      {!hideFooter && <Footer />}
      {showsDock && (
        <div
          aria-hidden
          className="h-[calc(env(safe-area-inset-bottom)+5.5rem)] md:hidden"
        />
      )}
    </>
  );
}
